/**
 * dd-cart-helpers.js — Facade
 *
 * This file is a thin delegation layer. All logic lives in the extracted modules:
 *   cart-errors.js   → window._ddCartErrors
 *   cart-toast.js    → window._ddCartToast
 *   cart-paint.js    → window._ddCartPaint
 *   cart-queue.js    → window._ddCartQueue
 *   cart-notify.js   → window._ddCartNotify
 *
 * This facade re-exports every function on window.ddCartHelpers so that
 * existing callers (product-form, mini-cart, cart-page, etc.) continue to work
 * without any import changes.
 */
(function () {
  'use strict';

  function q() { return window._ddCartQueue || {}; }
  function p() { return window._ddCartPaint || {}; }
  function n() { return window._ddCartNotify || {}; }
  function t() { return window._ddCartToast || {}; }
  function e() { return window._ddCartErrors || {}; }

  window.ddCartHelpers = {
    /* ── Queue / Mutation ── */
    queueMutate:              function () { return q().queueMutate.apply(null, arguments); },
    cartMutate:               function () { return q().cartMutate.apply(null, arguments); },
    mutateCartChange:         function () { return q().mutateCartChange.apply(null, arguments); },
    mutateCartUpdate:         function () { return q().mutateCartUpdate.apply(null, arguments); },
    makeCoalesceKey:          function () { return q().makeCoalesceKey.apply(null, arguments); },
    enqueueExternalMutation:  function () { return q().enqueueExternalMutation.apply(null, arguments); },
    ensureFreshCart:           function () { return q().ensureFreshCart.apply(null, arguments); },
    waitForIdle:              function () { return q().waitForIdle.apply(null, arguments); },
    recordRequest:            function () { return q().recordRequest.apply(null, arguments); },
    getMetrics:               function () { return q().getMetrics(); },
    getMetricsSummary:        function () { return q().getMetricsSummary(); },
    getQueueDebugState:       function () { return q().getQueueDebugState(); },
    resetMetrics:             function () { return q().resetMetrics(); },
    debugLog:                 function () { return q().debugLog.apply(null, arguments); },
    hasAuthoritativeCartShape:function () { return q().hasAuthoritativeCartShape.apply(null, arguments); },
    hasAuthoritativeMerchShape:function () { return q().hasAuthoritativeMerchShape.apply(null, arguments); },
    getLatestCart:             function () { return q().getLatestCart(); },
    seedLatestCart:            function () { return q().seedLatestCart.apply(null, arguments); },

    /* ── Line transaction (pending-action engine) ── */
    getActiveLineJob:          function () { return q().getActiveLineJob ? q().getActiveLineJob() : null; },
    registerCartMutationHook:  function () { return q().registerCartMutationHook.apply(null, arguments); },
    registerLineMutationPrepare: function () { return q().registerLineMutationPrepare.apply(null, arguments); },
    isLineMutationSource:      function () { return q().isLineMutationSource.apply(null, arguments); },

    /* ── Paint / Render ── */
    parseSectionHTML:          function () { return p().parseSectionHTML.apply(null, arguments); },
    replaceCartSections:       function () { return p().replaceCartSections.apply(null, arguments); },
    patchDrawerFromSection:    function () { return p().patchDrawerFromSection.apply(null, arguments); },
    replaceCartDrawerRootHTML: function () { return p().replaceCartDrawerRootHTML.apply(null, arguments); },
    withLocalShimmer:          function () { return p().withLocalShimmer.apply(null, arguments); },
    applyFooterFromCart:       function () { return p().applyFooterFromCart.apply(null, arguments); },
    consumeGranularFooterPending: function () { return p().consumeGranularFooterPending.apply(null, arguments); },
    isSectionFooterFresh:      function () { return p().isSectionFooterFresh(); },
    captureCartScrollSnapshot: function () { return p().captureCartScrollSnapshot.apply(null, arguments); },
    restoreCartScrollSnapshot: function () { return p().restoreCartScrollSnapshot.apply(null, arguments); },
    waitForDrawerSwapIdle:     function () { return p().waitForDrawerSwapIdle.apply(null, arguments); },
    tryApplyGranularMiniCart:  function () { return p().tryApplyGranularMiniCart.apply(null, arguments); },
    computeLinePricing:        function () { return p().computeLinePricing.apply(null, arguments); },
    predictLineItem:           function () { return p().predictLineItem.apply(null, arguments); },
    paintLineFromItem:         function () { return p().paintLineFromItem.apply(null, arguments); },
    captureLineSnapshot:       function () { return p().captureLineSnapshot.apply(null, arguments); },
    restoreLineSnapshot:       function () { return p().restoreLineSnapshot.apply(null, arguments); },
    updateDrawerFooterMeta:    function () { return p().updateDrawerFooterMeta.apply(null, arguments); },
    renderCodeChipsHtml:       function () { return p().renderCodeChipsHtml.apply(null, arguments); },
    renderCartLevelDiscountsHtml: function () { return p().renderCartLevelDiscountsHtml.apply(null, arguments); },

    /* ── Notify / Events / Utilities ── */
    publishCartUpdate:         function () { return n().publishCartUpdate.apply(null, arguments); },
    isProtectionLine:          function () { return n().isProtectionLine.apply(null, arguments); },
    extractCartFromEventDetail:function () { return n().extractCartFromEventDetail.apply(null, arguments); },
    normalizeCartUpdatedDetail:function () { return n().normalizeCartUpdatedDetail.apply(null, arguments); },
    formatMoney:               function () { return n().formatMoney.apply(null, arguments); },
    formatMoneyWithCurrency:   function () { return n().formatMoneyWithCurrency.apply(null, arguments); },
    cartDisplayCount:          function () { return n().cartDisplayCount.apply(null, arguments); },
    reserveCheckoutNav:        function () { return n().reserveCheckoutNav(); },
    estimatedCustomShipDate:   function () { return n().estimatedCustomShipDate(); },
    scheduleCloseCartAccordions: function () { return n().scheduleCloseCartAccordions.apply(null, arguments); },

    /* ── Toast ── */
    ddToast:                   function () { return t().ddToast.apply(null, arguments); },

    /* ── Errors ── */
    parseCartStockError:       function () { return e().parseCartStockError.apply(null, arguments); },
    stockErrorMessage:         function () { return e().stockErrorMessage.apply(null, arguments); },
    extractErrorText:          function () { return e().extractErrorText.apply(null, arguments); },
    getErrorStatus:            function () { return e().getErrorStatus.apply(null, arguments); }
  };

  window.ddToast = function () { return t().ddToast.apply(null, arguments); };
})();
